/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { EmployeeLocation } from '../../models/employee-location';

export interface GetEmployeeLocationByEmployeeId$Json$Params {

/**
 * The employee ID
 */
  employeeId: string;
}

export function getEmployeeLocationByEmployeeId$Json(http: HttpClient, rootUrl: string, params: GetEmployeeLocationByEmployeeId$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<EmployeeLocation>> {
  const rb = new RequestBuilder(rootUrl, getEmployeeLocationByEmployeeId$Json.PATH, 'get');
  if (params) {
    rb.path('employeeId', params.employeeId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<EmployeeLocation>;
    })
  );
}

getEmployeeLocationByEmployeeId$Json.PATH = '/api/EmployeeLocation/ByEmployee/{employeeId}';
